import React, { Component } from 'react'
import { Route, Switch } from 'react-router'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Loadable from 'react-loadable'

import { loadApp } from '../actions/appActions'
import MainLayout from '../layouts/MainLayout'
import {
  HomepageContainer,
  ReviewsContainer,
  CmsPageContainer,
  ErrorPageContainer,
  TaxonomyContainer,
} from '../containers'
import { getMeta, reviewsRoute, homepageRoute, cmsPageRoute, taxonomyRoute } from '../routes'
import LoadingProgressBar from '../components/LoadingProgressBar/LoadingProgressBar'
import { isMagnoliaApp, isHomepagePath } from '../helpers/pathCheck'

import './App.scss'

const DatePicker =
  process.env.CMS_API_ENV !== 'production'
    ? Loadable({
        loader: () =>
          import(/* webpackChunkName: "datepicker", webpackPrefetch: true */ '../components/DatePicker/DatePicker'),
        loading: () => null,
        modules: ['datepicker'],
      })
    : null

export class App extends Component {
  componentDidMount() {
    this.props.loadApp()
  }

  componentDidUpdate(prevProps) {
    const { history, cmsMeta, homepageMeta } = this.props
    const pathname = history.location.pathname

    if (prevProps && prevProps.meta === undefined) {
      const metaList = document.getElementsByTagName('META')
      const validMetaDesc = metaList && metaList[3] && metaList[3].name
      if (isMagnoliaApp(pathname) && cmsMeta) {
        global.document.title = cmsMeta.title
        validMetaDesc && metaList[3].setAttribute('content', cmsMeta.description)
      } else if (isHomepagePath(pathname) && homepageMeta) {
        global.document.title = homepageMeta.title
        validMetaDesc && metaList[3].setAttribute('content', homepageMeta.description)
      } else {
        // set default meta from route
        global.document.title = getMeta(pathname).title
        validMetaDesc && metaList[3].setAttribute('content', getMeta(pathname).description)
      }
    }
  }

  render() {
    const { history, isLoading } = this.props
    return (
      <MainLayout history={history}>
        {DatePicker && isMagnoliaApp(history.location.pathname) && <DatePicker />}
        <LoadingProgressBar loading={isLoading} />
        <Switch>
          <Route exact path={homepageRoute.path} component={HomepageContainer} />
          <Route path={reviewsRoute.path} component={ReviewsContainer} />
          <Route path={cmsPageRoute.path} component={CmsPageContainer} />
          <Route path={taxonomyRoute.path} component={TaxonomyContainer} />
          <Route component={ErrorPageContainer} />
        </Switch>
      </MainLayout>
    )
  }
}

App.propTypes = {
  isLoading: PropTypes.bool,
  loadApp: PropTypes.func,
}

const mapStateToProps = (state) => {
  const isLoading = state.homepageApp.isLoading || state.cmsApp.isLoading || state.reviewsApp.isLoading
  return {
    cmsMeta: state.cmsApp.cmsData?.meta,
    homepageMeta: state.homepageApp?.homepageData?.meta,
    isLoading,
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      loadApp,
    },
  )(App),
)
